import React from 'react';
import { Users as UsersIcon, ScanLine, Mail, ShieldCheck } from 'lucide-react';
import PieCountryCard from './PieCountryCard';
import StatsCard from './StatsCard';
import OrganizationStatsCard from './OrganizationStatsCard';
import InvestigationStatusCard from './InvestigationStatusCard';
import { AdminDashboard } from '../../types/interfaces';
import { useTranslation } from 'react-i18next';

interface Props {
  data: AdminDashboard;
  onSelectInvestigationStatus: (s: 'accepted'|'under_review'|'rejected'|'deleted_by_user') => void;
  onOpenContactOrgs: (f?: 'available'|'contacted'|'all') => void;
}

const DashboardView: React.FC<Props> = ({ data, onSelectInvestigationStatus, onOpenContactOrgs }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* fila superior */}
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <PieCountryCard
          title={t('admin.organizations_by_country')}
          total={data.total_organizations}
          data={data.top_countries}
        />
        <PieCountryCard
          title={t('admin.reports_by_country')}
          total={data.total_reports}
          data={data.top_reports_countries}
        />
        <InvestigationStatusCard
          total={data.total_investigations}
          byStatus={data.investigations_by_status}
          onSelect={onSelectInvestigationStatus}
        />
        <OrganizationStatsCard
          icon={<UsersIcon className="h-5 w-5" />}
          total={data.num_total_orgs}
          contacted={data.num_total_orgs_contacted}
          available={data.available_organizations}
          onActionClick={onOpenContactOrgs}
        />
      </div>

      {/* estadísticas simples */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatsCard
          title={t('admin.users')}
          total={data.total_users}
          last24h={data.users_last_24h}
          icon={<UsersIcon className="h-5 w-5" />}
        />
        <StatsCard
          title={t('admin.scan_requests')}
          total={data.total_scan_requests}
          last24h={data.scan_requests_last_24h}
          icon={<ShieldCheck className="h-5 w-5" />}
        />
        <StatsCard
          title={t('admin.contact_forms')}
          total={data.total_contact_forms}
          last24h={data.contact_forms_last_24h}
          icon={<Mail className="h-5 w-5" />}
        />
        <StatsCard
          title={t('admin.executed_scans')}
          total={data.total_scans}
          last24h={data.scans_last_24h}
          icon={<ScanLine className="h-5 w-5" />}
        />
      </div>
    </>
  );
};

export default DashboardView;
